export class ModeloOrganos {
    "idOrgano": number = null;
    "nombre": string = "";
    "esOrdinario": boolean = false;
    "esProceso": boolean = false;
    "estatus": boolean = null;
}